import React from "react";
import {
  isMultiRaceBet,
  isPickBetSub
} from "@tvg/sh-lib-my-bets/utils/raceDetails";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";
import {
  LegScratchNotificationContainer,
  LegScratchNotification
} from "../styled-components";

export interface ScratchNotificationsProps {
  wagerTypeCode: WagerTypeCodesEnum;
  isDesktop: boolean;
  hasAlternateReplacement: boolean;
}

const ScratchNotifications = ({
  wagerTypeCode,
  isDesktop,
  hasAlternateReplacement
}: ScratchNotificationsProps) => {
  const showFavoriteMsg = wagerTypeCode && isPickBetSub(wagerTypeCode);
  const showScratchMsgDetails = wagerTypeCode && isMultiRaceBet(wagerTypeCode);

  if (!showScratchMsgDetails) {
    return null;
  }

  return (
    <LegScratchNotificationContainer isDesktop={isDesktop}>
      {hasAlternateReplacement && (
        <LegScratchNotification data-qa-label="LegScratchNotification">
          Scratch will be replaced with the alternate selection.
        </LegScratchNotification>
      )}
      {showFavoriteMsg && !hasAlternateReplacement && (
        <LegScratchNotification data-qa-label="LegScratchNotification">
          Scratch will be replaced with the FAV.
        </LegScratchNotification>
      )}
      <LegScratchNotification data-qa-label="LegScratchNotification">
        Awaiting official result to confirm the bet status.
      </LegScratchNotification>
    </LegScratchNotificationContainer>
  );
};

export default ScratchNotifications;
